import { axios } from "@/utils";

export const MonitorPkgService = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/v1/user/choose-plan`, params);
};

export const MonitorGetAccountService = async (params: any) => {
  return await axios.get(`/monitrees-monitor-bff/plan-order/accounts`, {
    params,
  });
};

export const MonitorCreatePayService = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/plan-order/create`, params);
};
